import { BadgeCheck } from "lucide-react";

export function isFullyVerified(user) {
  if (!user) return false;
  return Boolean(user.identity_verified);
}

export function VerifiedTick({ user, className = "" }) {
  if (!isFullyVerified(user)) return null;
  return (
    <BadgeCheck
      aria-label="Fully verified"
      title="Fully verified"
      className={`inline-block h-4 w-4 shrink-0 fill-sky-400 text-white ${className}`}
    />
  );
}

export default function VerifiedName({ user, name, className = "", nameClassName = "", tickClassName = "" }) {
  const displayName = name || user?.username || user?.name || "Player";
  return (
    <span className={`inline-flex min-w-0 items-center gap-1.5 ${className}`}>
      <span className={`min-w-0 truncate ${nameClassName}`}>{displayName}</span>
      <VerifiedTick user={user} className={tickClassName} />
    </span>
  );
}
